import React from 'react';

import { Text, InlineNotification } from '@lucidhq/lucidium';

import { t } from '~/utils/i18n';

import { FileTypeInfo } from './FileTypeInfo';
import { UploadError } from './useFileUplaod';

export const ErrorBanner = ({ type }: { type?: UploadError | null }) => {
  const title =
    type === UploadError.INVALID_TYPE || type === UploadError.INVALID_SIZE
      ? t(`campaignManager.media.uploadModal.validation.${type}`)
      : t('campaignManager.media.uploadModal.validation.uploadFailed');

  const description =
    type === UploadError.INVALID_TYPE ? (
      <FileTypeInfo />
    ) : type === UploadError.INVALID_SIZE ? (
      <Text>{t('campaignManager.media.uploadModal.fileSize')}</Text>
    ) : (
      <Text>{t('campaignManager.media.uploadModal.uknonwnError')}</Text>
    );

  return (
    <InlineNotification palette="danger" title={title}>
      {description}
    </InlineNotification>
  );
};
